<input-file>
    <div>
        <label for="{ props.ckey }" class="block text-sm/6 font-medium text-gray-900">{ props.label }</label>
        <div class="mt-2 flex items-center gap-x-3">
            <!-- Anteprima immagine -->
            <img if="{ state.preview_url }" class="size-12 object-cover rounded-md" src="{ state.preview_url }" alt="Anteprima immagine" />
            <svg if="{ !state.preview_url }" class="size-12 text-gray-300" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M1.5 6a2.25 2.25 0 0 1 2.25-2.25h16.5A2.25 2.25 0 0 1 22.5 6v12a2.25 2.25 0 0 1-2.25 2.25H3.75A2.25 2.25 0 0 1 1.5 18V6ZM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0 0 21 18v-1.94l-2.69-2.689a1.5 1.5 0 0 0-2.12 0l-.88.879.97.97a.75.75 0 1 1-1.06 1.06l-5.16-5.159a1.5 1.5 0 0 0-2.12 0L3 16.061Zm10.125-7.81a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z" clip-rule="evenodd"></path>
            </svg>

            <!-- Pulsante per scegliere file -->
            <button type="button" class="rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50" onclick="{
                        openFilePicker
                    }">
                { state.preview_url ? "Cambia" : "Carica" }
            </button>
        </div>

        <!-- Input file nascosto -->
        <input type="file" id="{ props.ckey }" accept="{ props.accept }" class="hidden" onchange="{
                    handleFileUpload
                }">
        <p if="{ props.show_help }" class="mt-3 text-sm leading-6 text-gray-600"><slot/></p>
    </div>

    <script>
        import eventBus from '/src/utils/event-bus'
        import { EVENTS } from '/src/utils/constants'

        export default {

            onBeforeMount(props, state) {
                this.state = {
                    file: null,
                    preview_url: props.preview_url ? props.preview_url : ''
                }
                eventBus.on(EVENTS.INPUT.RESET, this.handleResetInput)
            },

            onBeforeUnmount(props, state) {
                eventBus.off(EVENTS.INPUT.RESET, this.handleResetInput)
            },

            handleResetInput(e) {
                if (e.ckey === this.props.ckey) {
                    this.update({
                        file: null,
                        preview_url: ''
                    })
                    this.$("input").value = ""
                }
            },

            openFilePicker() {
                this.$('#' + this.props.ckey).click();
            },

            /** Gestisce la selezione del file */
            handleFileUpload(e) {
                const file = e.target.files[0]; // Ottiene il file selezionato

                if (file) {
                    const reader = new FileReader();
                    reader.onload = () => {
                        this.update({
                            file: file,
                            preview_url: reader.result
                        });
                        eventBus.trigger(EVENTS.INPUT.UPDATED, {
                            ckey: this.props.ckey,
                            value: file
                        })
                    };
                    reader.readAsDataURL(file);
                }
            }
        }
    </script>
</input-file>